import {defineField, defineType} from 'sanity'
import {internalPages} from '../../structure/deskStructure'

export default defineType({
  name: 'infoBarLink',
  type: 'object',
  title: 'Info Bar Link',
  fieldsets: [
    {
      name: 'desktop',
      title: 'Desktop',
      options: {
        collapsible: true,
        collapsed: false,
      },
    },
    {
      name: 'mobile',
      title: 'Mobile',
      options: {
        collapsible: true,
        collapsed: false,
      },
    },
  ],
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Type',
      name: 'type',
      type: 'string',
      options: {
        list: [
          {title: 'Internal', value: 'internal'},
          {title: 'External', value: 'external'},
          {title: 'Vehicle Selector', value: 'vehicleSelector'},
          {title: 'Custom', value: 'custom'},
        ],
      },
      initialValue: 'custom',
    }),
    defineField({
      title: 'URL (i)',
      name: 'url_internal',
      description: 'Search for internal page.',
      type: 'reference',
      to: internalPages.map((p) => ({type: p})),
      hidden: ({parent}) => parent?.type !== 'internal',
      options: {
        disableNew: true,
      },
    }),
    defineField({
      title: 'URL (e)',
      name: 'url_external',
      type: 'url',
      hidden: ({parent}) => parent?.type !== 'external',
      validation: (rule) =>
        rule.uri({
          allowRelative: true,
          scheme: ['https', 'http', 'mailto', 'tel'],
        }),
    }),
    defineField({
      title: 'URL (c)',
      name: 'url_custom',
      type: 'string',
      initialValue: '#url',
      hidden: ({parent}) => parent?.type !== 'custom',
    }),
    defineField({
      title: 'Target',
      name: 'target',
      type: 'string',
      options: {
        list: [
          {title: 'Self', value: '_self'},
          {title: 'New Window', value: '_blank'},
        ],
      },
      initialValue: '_self',
      hidden: ({parent}) => parent?.type === 'vehicleSelector',
    }),
    defineField({
      name: 'backgroundColor',
      title: 'Background Color',
      type: 'colorPicker',
      fieldset: 'desktop',
    }),
    defineField({
      name: 'backgroundColorHover',
      title: 'Background Color Hover',
      type: 'colorPicker',
      fieldset: 'desktop',
    }),
    defineField({
      name: 'textColor',
      title: 'Text Color',
      type: 'string',
      fieldset: 'desktop',
      options: {
        list: [
          {title: 'White', value: 'white'},
          {title: 'Black', value: 'black'},
        ],
        layout: 'radio',
      },
      initialValue: 'white',
    }),
    defineField({
      name: 'textColorHover',
      title: 'Text Color Hover',
      type: 'string',
      fieldset: 'desktop',
      options: {
        list: [
          {title: 'White', value: 'white'},
          {title: 'Black', value: 'black'},
        ],
        layout: 'radio',
      },
      initialValue: 'white',
    }),
    defineField({
      name: 'backgroundColorMobile',
      title: 'Background Color',
      type: 'colorPicker',
      fieldset: 'mobile',
    }),
    defineField({
      name: 'backgroundColorHoverMobile',
      title: 'Background Color Hover',
      type: 'colorPicker',
      fieldset: 'mobile',
    }),
    defineField({
      name: 'textColorMobile',
      title: 'Text Color',
      type: 'string',
      fieldset: 'mobile',
      options: {
        list: [
          {title: 'White', value: 'white'},
          {title: 'Black', value: 'black'},
        ],
        layout: 'radio',
      },
      initialValue: 'white',
    }),
    defineField({
      name: 'textColorHoverMobile',
      title: 'Text Color Hover',
      type: 'string',
      fieldset: 'mobile',
      options: {
        list: [
          {title: 'White', value: 'white'},
          {title: 'Black', value: 'black'},
        ],
        layout: 'radio',
      },
      initialValue: 'white',
    }),
  ],
})
